export const profileRoute = () => '/profile'
